// @ts-nocheck
const ADVISER_FIELDS = [
  'auditor',
  'lastReviewFacilitator',
  'recruitingAdviser',
  'remunerationAdviser',
]

// Returns a list of companies from the given list which have the given adviserName in any of the adviser fields
export const findCompaniesUsingAdviser = (companies, adviserName) => {

  const search = adviserName
  return companies.filter(company =>
    ADVISER_FIELDS.some(field => {

      const adviserValue =
        company.advisers?.[field]

      if (!adviserValue)
        return false

      const advisers = adviserValue
        .split(',')
        .map(name => name.trim())

      return advisers.includes(search)
    })
  )
}

// find company in advisersMeta with company number matching companyNumber
export const findCompanyByNumber = (advisersMeta, companyNumber) => {
  return (advisersMeta ?? []).find(
    company => company.companyNumber === companyNumber
  )
}